import React from "react";
import "./ConfirmationModal.css";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Delete",
  cancelText = "Cancel",
  type = "danger", // danger, warning, info
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const getButtonClass = () => {
    switch (type) {
      case "danger":
        return "btn-danger";
      case "warning":
        return "btn-warning";
      case "info":
        return "btn-info";
      default:
        return "btn-danger";
    }
  };

  const getIconClass = () => {
    switch (type) {
      case "danger":
        return "fas fa-exclamation-triangle text-danger";
      case "warning":
        return "fas fa-exclamation-circle text-warning";
      case "info":
        return "fas fa-info-circle text-info";
      default:
        return "fas fa-exclamation-triangle text-danger";
    }
  };

  return (
    <div className="confirmation-modal-overlay" onClick={handleBackdropClick}>
      <div className="confirmation-modal">
        <div className="confirmation-modal-header">
          <div className="confirmation-modal-icon">
            <i className={getIconClass()}></i>
          </div>
          <h3 className="confirmation-modal-title">{title}</h3>
        </div>

        <div className="confirmation-modal-body">
          <div className="confirmation-modal-message">
            {typeof message === "string"
              ? message.split("\n").map((line, index) => (
                  <p
                    key={index}
                    className={line.startsWith("-") ? "deletion-item" : ""}
                  >
                    {line}
                  </p>
                ))
              : message}
          </div>
        </div>

        <div className="confirmation-modal-footer">
          <button className="btn btn-secondary" onClick={onClose} type="button">
            {cancelText}
          </button>
          <button
            className={`btn ${getButtonClass()}`}
            onClick={onConfirm}
            type="button"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
